import { render, staticRenderFns } from "./invoiceBlock.vue?vue&type=template&id=94fa1364&scoped=true"
import script from "./invoiceBlock.vue?vue&type=script&lang=js"
export * from "./invoiceBlock.vue?vue&type=script&lang=js"
import style0 from "./invoiceBlock.vue?vue&type=style&index=0&id=94fa1364&prod&lang=scss"
import style1 from "./invoiceBlock.vue?vue&type=style&index=1&id=94fa1364&prod&scoped=true&lang=scss"
import style2 from "./invoiceBlock.vue?vue&type=style&index=2&id=94fa1364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fa1364",
  null
  
)

export default component.exports